import swal from 'sweetalert2';
import { Table, TableColumn, Select, Option } from 'element-ui'
import { Pagination as LPagination } from '@/components/index'
import ResourceSvc from '@/services/resource.svc.js';
import store from '@/services/store.js';
import { EventBus } from '@/services/Event.js';

const svc = new ResourceSvc();

export default {
    props: ['courseId'],
    name: 'AdminAttendants',
    components: {
        LPagination,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        pagedData() {
            return this.tableData.slice(this.from, this.to)
        },
        to() {
            let highBound = this.from + this.pagination.perPage
            if (this.total < highBound) {
                highBound = this.total
            }
            return highBound
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1)
        },
        total() {
            this.pagination.total = store.getters.getCourseAttendantsTotal;
            return store.getters.getCourseAttendantsTotal;
        }
    },
    watch: {
        currentTypeId: function (newId) {
            this.queriedData();
        }
    },
    data() {
        return {
            title: "Attendants Tables",
            searchTimeout: null,
            isForcedLoad: false,
            savedSearchQuery: '',
            searchQuery: '',
            dataLoad: false,
            savedCurrentTypeId: 0,
            pagination: { perPage: 5, currentPage: 1, perPageOptions: [5, 10, 25, 50], total: 0, savedPageIndex: 0, savedPerPage: 0 },
            tableColumns:
                [{ prop: 'firstName', label: 'First Name', minWidth: 120 },
                { prop: 'lastName', label: 'Last Name', minWidth: 150 },
                { prop: 'gender', label: 'Gender', minWidth: 67 },
                { prop: 'phone', label: 'Phone', minWidth: 125 },
                { prop: 'email', label: 'Email', minWidth: 170 },
                { prop: 'tiNumber', label: 'TI #', minWidth: 84}],
            tableData: []
        }
    },
    methods: {
        showConfirmSwal(message, userId, isConfirmedNow) {
            var self = this;
            swal({
                title: 'Please confirm', text: message, type: 'warning', showCancelButton: true, buttonsStyling: false,
                confirmButtonClass: 'btn btn-default', cancelButtonClass: 'btn btn-danger', confirmButtonText: 'Yes', cancelButtonText: 'No'
            }).then(function (result) {
                if (result.value) {

                    var successMessage = "Succes. User is marked as registered";
                    if (isConfirmedNow) {
                        successMessage = "Registration cancelled successfully";
                    }
                    svc.updateRegistrationStatus({ userId: userId, courseId: self.courseId, newStatus: !isConfirmedNow }).then(response => {
                        if (response.body.isSuccess) {
                            self.$notify({ message: successMessage, type: 'success' });
                            self.loadTable();
                            EventBus.$emit("admin_load_course");
                            EventBus.$emit("application_answers_load");
                        }
                        else {
                            self.$notify({ message: "Something went wrong. Message: " + response.body.message, type: 'danger' });
                        }
                    },
                    response => {
                        self.$notify({ message: "Something went wrong. Reload page and try again. In other case, please contact with dev team.", type: 'danger' });
                    });
                }
            });
        },
        changeRegistrationStatus(userId, isConfirmedNow) {
            var self = this;
            var user = self.tableData.filter(function (item) {
                return item.id == userId;
            });
            var undo = "undo"
            if (isConfirmedNow) {
                undo = "";
            }

            this.showConfirmSwal("Do you really want to " + undo + " cancel registration for " + user[0].firstName + " " + user[0].lastName + "?", userId, isConfirmedNow);
        },
        queriedData(forced) {
            if (this.searchQuery != this.savedSearchQuery && !this.isForcedLoad && !forced) {
                var self = this;
                if (this.searchTimeout) {
                    return this.tableData;
                }
                else {
                    this.searchTimeout = setTimeout(function () { self.searchTimeout = null; self.queriedData(true) }, 750);
                    return this.tableData;
                }
            }
            if (this.dataLoad)
                return this.tableData;
            if (this.pagination.savedPageIndex == this.pagination.currentPage && this.pagination.perPage == this.pagination.savedPerPage &&
                this.searchQuery == this.savedSearchQuery && !this.isForcedLoad)
                return this.tableData;

            return this.loadTable();
        },
        loadTable() {
            var conf = { id: this.courseId, take: this.pagination.perPage, skip: this.from, search: this.searchQuery };
            if (conf.skip < 0) conf.skip = 0;

            while (this.pagination.total <= conf.skip && conf.skip) {
                this.pagination.currentPage--;
                conf.skip -= this.pagination.perPage;
                if (conf.skip < 0)  conf.skip = 0;
            }

            this.dataLoad = true;
            var self = this;

            svc.getCourseAttendants(conf).then(response => {
                self.dataLoad = false;
                this.isForcedLoad = false;
                self.tableData = response.body.data;
                store.commit('setCourseAttendantsTotal', response.body.count);
                self.pagination.savedPageIndex = self.pagination.currentPage;
                self.pagination.savedPerPage = self.pagination.perPage;
                self.savedSearchQuery = self.searchQuery;
                return self.tableData;
            }, response => {
                //todo add interseptor
                self.tableData = [];
                self.pagination.savedPageIndex = self.pagination.currentPage;
                self.pagination.savedPerPage = self.pagination.perPage;
                self.savedSearchQuery = self.searchQuery;
                self.dataLoad = false;
                self.isForcedLoad = false;
                return [];
            });
        },
        exportToExcel(attendace, answers) {
            if (attendace && attendace.length > 0) {
                var workbook = XLSX.utils.book_new();

                var ws = XLSX.utils.json_to_sheet(attendace, { skipHeader: true });
                XLSX.utils.book_append_sheet(workbook, ws, "Attendance");

                ws = XLSX.utils.json_to_sheet(answers, { skipHeader: true });
                XLSX.utils.book_append_sheet(workbook, ws, "Answers");
                XLSX.writeFile(workbook, "Course_Attendance.xlsx");
            }
            else {
                this.$notify({ message: "Something went wrong.", type: 'danger' });
            }
        },
        createCsv() {
            var self = this;
            if (self.courseId) {
                svc.getCourseAttendanceInfo(self.courseId)
                    .then(response => {
                        if (response.body.isSuccess) {
                            self.exportToExcel(response.body.outputData.attendance, response.body.outputData.answers)
                        }
                        else {
                            self.$notify({ message: "Something went wrong. Message: " + response.body.message, type: 'danger' });
                        }
                    }, () => {
                            self.$notify({ message: "Something went wrong.", type: 'danger' });
                    });
            }
        },
        createCsvOld() {
            var url = "/api/Course/GetCourseAttendantsFile/?id=" + this.courseId;
            var link = document.createElement("a");
            link.setAttribute("href", url);
            link.setAttribute("download", "attendants.xlsx");
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/admin/courses/course-details/attendants/attendants.js